import { render } from "./QualityRecord.vue?vue&type=template&id=e87c187c&scoped=true"
import script from "./QualityRecord.vue?vue&type=script&lang=js"
export * from "./QualityRecord.vue?vue&type=script&lang=js"

import "./QualityRecord.vue?vue&type=style&index=0&id=e87c187c&lang=scss&scoped=true"
import "./QualityRecord.vue?vue&type=style&index=1&id=e87c187c&lang=scss"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87c187c"]])

export default __exports__